import { render } from "./AppTest.vue?vue&type=template&id=24f835c2"
import script from "./AppTest.vue?vue&type=script&lang=js"
export * from "./AppTest.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__